import { Link } from "react-router-dom";
import { useApi } from "@/lib/api";
import { EventCard } from "@/components/site/EventCard";
import { LoadingGrid } from "@/components/site/PageHeader";

const dayMonth = (iso) => new Date(iso).toLocaleDateString("fr-FR", { weekday: "short", day: "numeric", month: "long" });

const Grid = ({ events, testId }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-16" data-testid={testId}>
    {events.map((e, i) => <EventCard key={e.id} event={e} index={i} />)}
  </div>
);

// « Ce week-end en club » : Friday → Sunday concerts in places filed under Clubs
export const ClubWeekend = () => {
  const { data, isLoading } = useApi("/events/club-weekend");
  if (isLoading) return <LoadingGrid />;
  const events = Array.isArray(data?.events) ? data.events : [];
  const next = Array.isArray(data?.next) ? data.next : [];

  return (
    <div data-testid="club-weekend">
      {data?.start && (
        <p className="text-sm font-bold uppercase tracking-[0.2em] text-primary mb-10" data-testid="club-weekend-range">
          Du {dayMonth(data.start)} au {dayMonth(data.end)}
        </p>
      )}
      {events.length > 0 ? (
        <Grid events={events} testId="club-weekend-grid" />
      ) : (
        <div data-testid="club-weekend-empty">
          <p className="font-display uppercase text-4xl md:text-6xl text-white">Pas de soirée club ce week-end<span className="text-primary">.</span></p>
          <p className="text-zinc-400 mt-4 max-w-lg">
            Aucune date LGTDZ en club ce week-end. Retrouve tous les clubs sur <Link to="/lieux/clubs" className="text-white underline decoration-primary underline-offset-4 hover:text-primary" data-testid="club-weekend-places-link">la carte des lieux</Link>.
          </p>
          {next.length > 0 && (
            <div className="mt-16">
              <p className="font-display uppercase text-2xl md:text-3xl text-white mb-8">Les prochaines soirées club</p>
              <Grid events={next} testId="club-weekend-next-grid" />
            </div>
          )}
        </div>
      )}
    </div>
  );
};
